var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-list-item",
        {
          style: {
            "background-color": _vm.showDistinte ? "#f2f2f2" : "#ffffff",
          },
          attrs: { "three-line": "" },
          on: {
            click: function ($event) {
              return _vm.toggleShowDistinte()
            },
          },
        },
        [
          _c(
            "v-list-item-content",
            [
              _c("v-list-item-title", [
                _vm._v(" Modello: "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.gruppo.modello) +
                      " - " +
                      _vm._s(_vm.gruppo.descrizioneModello)
                  ),
                ]),
              ]),
              _c("v-list-item-subtitle", [
                _vm._v(" Num. Distinte: "),
                _c("strong", [_vm._v(_vm._s(_vm.distinte.length))]),
              ]),
            ],
            1
          ),
          _vm.viewInValidazioneIcon
            ? _c(
                "v-list-item-avatar",
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "amber lighten-1 white--text",
                      attrs: {
                        title:
                          "Contiene " +
                          _vm.gruppo.numDistinteConConsumiDaValidare +
                          " " +
                          (_vm.gruppo.numDistinteConConsumiDaValidare == 1
                            ? "distinta"
                            : "distinte") +
                          " con variazioni in attesa di validazione",
                      },
                    },
                    [_vm._v(" mdi-exclamation-thick ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.viewDraftIcon
            ? _c(
                "v-list-item-avatar",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "primary white--text",
                      attrs: {
                        title:
                          "Contiene " +
                          _vm.gruppo.numDistinteConVariazioniInDraft +
                          " " +
                          (_vm.gruppo.numDistinteConVariazioniInDraft == 1
                            ? "distinta"
                            : "distinte") +
                          " con variazioni in attesa di sincronizzazione",
                      },
                    },
                    [_vm._v(" mdi-cloud-sync ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.viewConsolidateIcon
            ? _c(
                "v-list-item-avatar",
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "green white--text",
                      attrs: {
                        title:
                          "Contiene " +
                          _vm.gruppo.numDistinteConVariazioniConsolidate +
                          " " +
                          (_vm.gruppo.numDistinteConVariazioniConsolidate == 1
                            ? "distinta"
                            : "distinte") +
                          " con variazioni sincronizzate",
                      },
                    },
                    [_vm._v(" mdi-cloud-check ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-icon",
            {
              class: { "active-expansion": _vm.showDistinte },
              staticStyle: { "margin-left": "10px" },
            },
            [_vm._v("mdi-chevron-down")]
          ),
        ],
        1
      ),
      _vm.showDistinte
        ? _c(
            "v-list-item",
            [_c("ConsumiGestioneBC", { attrs: { distinte: _vm.distinte } })],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }